<template>
  <!-- htmlファイル側の「<router-view>」内に表示する内容 -->
    <nav>
      <div class="d-grid gap-3 vy-right-nav" >
        
        <input type="text" class="form-control" v-if="GlobalData.user_name"  v-show="login_status == 'login'" v-bind:value="GlobalData.user_name" style="border: 2px solid #FF0000;" readonly="readonly">
        <input type="text" class="form-control" v-else  v-show="login_status == 'login'" value="未登録" readonly="readonly" style="border: 2px solid #FF0000;">


        <p v-if="login_status == 'login'" v-on:click="mypage" class="btn btn-secondary vy-btn-secondary vy-right-nav-btn shadow">
            マイページ
        </p>
        <!-- 複数ユーザーの対応 PC版 右メニューに「ユーザー追加」ボタンと「ユーザー切替／削除」ボタンの追加
             追加ボタンは、切替メニューの方で行うようにした。
        <p v-if="login_status == 'login' && family_flg" v-on:click="multipleprofile_entry" class="btn btn-secondary vy-btn-secondary vy-right-nav-btn shadow">
            ユーザー追加
        </p>
        -->
        
        <p v-if="login_status == 'logout'" v-on:click="login" class="btn btn-secondary vy-btn-secondary vy-right-nav-btn shadow">
            ログイン
        </p>
        
        <p v-if="login_status == 'logout'" v-on:click="user_signin"  class="btn btn-secondary vy-btn-secondary vy-right-nav-btn shadow">
            新規ユーザー登録
        </p>
        <p v-on:click="search" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">体験プログラムを探す</p>
        
        <p v-if="jizen_dsp == 1" v-on:click="jizen" class="btn btn-secondary vy-btn-primary vy-right-nav-btn shadow">事前説明会一覧</p>
        <p v-if="login_status == 'login'" v-on:click="notification" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow" style="background-color:red">お知らせ</p>

        <p v-if="login_status == 'login' && family_flg" v-on:click="multipleprofile_switch" class="btn btn-secondary vy-btn-secondary vy-right-nav-btn shadow">
            ユーザー切替
        </p>

        <!--
        <router-link to="/" class="btn btn-primary vy-btn-primary vy-right-nav-btn shadow">
            体験プログラムを探す
        </router-link>-->
        <div class="container">
            <!--
            <p v-on:click="toiawase" style="cursor:pointer">お問合せ<br/></p>-->
            <!--
            <div v-if="login_status == 'login'" style="padding: 10px; margin-bottom: 20px; border-radius: 10px; color:white; background-color:red ">
            ログイン中
            </div>--> <!--
            <p v-if="login_status == 'logout'" v-on:click="user_signin" style="cursor:pointer">新規ユーザー登録<br/></p>
            <p v-if="login_status == 'logout'" v-on:click="user_joho" style="cursor:pointer">会員情報登録<br/></p>
             
            <p v-if="login_status == 'login'" v-on:click="log_out" style="cursor:pointer">ログアウト</p> -->
            <hr style="margin-top:0">
        
                
            <p v-on:click="shakyo_policy" style="cursor:pointer">プライバシーポリシー<br>（社協）</p>
            <p v-on:click="privacy_policy" style="cursor:pointer">プライバシーポリシー<br>（ボラ活エール）</p>
            <p v-on:click="riyo_kiyaku" style="cursor:pointer">利用規約</p>
        </div>
      </div>
      <QRCodeVue3
          v-bind:value=set_url
          :width="100"
          :height="100"
          :qrOptions="{ typeNumber: 0, mode: 'Byte', errorCorrectionLevel: 'H' }"
          :imageOptions="{ hideBackgroundDots: true, imageSize: 0.4, margin: 0 }"
          :dotsOptions="{
            type: 'square',
            color: '#000000',
            gradient: {
              type: 'linear',
              rotation: 0,
              colorStops: [
                { offset: 0, color: '#000000' },
                { offset: 1, color: '#000000' },
              ],
            },
          }"
          :backgroundOptions="{ color: '#ffffff' }"
          :cornersSquareOptions="{ type: 'dot', color: '#000000' }"
          :cornersDotOptions="{ type: undefined, color: '#000000' }"
          fileExt="png"
          :download="false"
          myclass="my-qur"
          imgclass="img-qr"
          downloadButton="my-button"
          :downloadOptions="{ name: 'vqr', extension: 'png' }"
        />
        <br>
        スマートフォンで閲覧する
    </nav>
</template>

<style scoped>

button{
  padding: 0;
}

</style>

<script setup>
/* eslint-disable */
import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails } from 'amazon-cognito-identity-js'
  import QRCodeVue3 from "qrcode-vue3";
import { useRouter,useRoute } from 'vue-router'
import { ref, watch } from 'vue'
import { GlobalData, login_check, logout } from '../js/userdata.js'

import axios from 'axios'
const emit = defineEmits(['call'])
const login_status = ref("logout")

/* 変数の記述 */
let router = useRouter()
let route = useRoute()

const cityname = route.params.shakyo

let protocol = location.protocol
let host = location.host

if(host == "localhost:8080"){
    protocol = "https:"
    host = "www.volukatsu-taiken.net"
}

let set_url = protocol+"//"+host+"/"+cityname+"/Taiken/"
const search = function() {
    router.push('/'+cityname+'/Taiken/Program')
    
}
const jizen = function() {
    router.push('/'+cityname+'/Taiken/Jizen')
    
}

const notification = function(){
    router.push('/'+cityname+'/Taiken/notification')

}
const toiawase = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    //router.push('/User/toiawase')
}
const login = function() {
    if(route.params.cmd == "detail" || route.params.cmd == "checktaiken" || route.params.cmd == "checkjizen"){
        emit('call', { cmd:'login',id:''})
    }else{
        router.replace('/'+cityname+'/Taiken/login')
    }
}
const mypage = function() {
    if(route.params.cmd == "mypage"){
        router.go('/'+cityname+'/Taiken/mypage' )
    }else{
        router.replace('/'+cityname+'/Taiken/mypage' )
    }
}

// ログイン後のプロフィール登録確認画面を表示する。 この機能は、切替メニュー入れた
//const multipleprofile_entry = function() {
//    router.push('/'+cityname+'/Taiken/multipleprofile')
//}

// ログイン後のユーザー切替え画面を表示する。
const multipleprofile_switch = function() {
    emit('call', { cmd:'multipleprofile_switch',id:GlobalData.user_id})
}

const log_out = function() {
    //document.getElementById("vy_responsive_menu_close").click();
    emit('call', { cmd:'logout',id:''})
}
const login_mode = () => {

    if ( GlobalData.$User_email) {
        login_status.value = "login"
    } else {
        login_status.value = "logout"
    }

    //alert("login_status:"+login_status.value)
}
const user_signin = () => {
    router.replace('/'+cityname+'/Taiken/user_signin' )
}
const user_joho = () => {
    emit('call', { cmd:'user_toroku', id:'' })
}

const riyo_kiyaku = function() { 
    let set_path = "/Condition"
    router.push(set_path)
}
const privacy_policy = function() { 
    let set_path = "/Policy"
    router.push(set_path)
}
const shakyo_policy = function() { 
    router.push( '/'+cityname+'/Taiken/Policy')
}

let family_flg = ref(false)  // 家族フラグ(家族の登録が出来る)が設定されている時は、右メニューのボタンが表示される

let family_flg_get_error = 0
const family_flg_get = () => {
    let res = null
    axios.post(GlobalData.$API_URL+"TaikenAccountUser_read", {taikenuser_id:GlobalData.user_id})
    .then(response => {
        
        if(response.data.accountuser){
            res = response.data.accountuser
            family_flg.value = res['family']

        } else {
            family_flg.value = false
        }
    })
    .catch(error => {
        if(family_flg_get_error == 6){
            alert(error + GlobalData.$axios_error)
        }else{
            family_flg_get_error++
            setTimeout(function(){family_flg_get()},"1000")
        }
        
    })
}

let jizen_dsp = ref(0)
let jizen_dsp_error = 0
/*

const jizen_read = () => {

    const today = new Date()
    let set_date = new Date(today);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
            
    let today_set = set_date.getFullYear()+"-"+(set_date.getMonth()+1)+"-"+set_date.getDate()

    // 今日以前に締め切った事前説明会は除く
    let search_param = {"shimekiri_date":today_set}
    search_param.choson_code = cityname
    axios.post(GlobalData.$API_URL+"Jizen_get", search_param)
    .then(response => {
        
        let program = response.data.jizen
        let jizen_kensu = 0
        // 締め切られていない事前説明会を取得
        if(program.length != 0){
            for(let i=0;i<program.length;i++){
            //   alert(JSON.stringify(program[i]))
            
                let today = new Date()


                let shimekiri = new Date(program[i].shimekiri_date +" 23:59:59")
                
                if (shimekiri >= today) {
                    jizen_kensu++
                }
            }
        }


        // すべての事前説明会が締め切られていたらボタンは表示しない
        if(jizen_kensu == 0){
        }else{
            jizen_dsp.value = 1
        }
    
    })
    .catch(error => {
        if(jizen_dsp_error == 6){
            alert(error + GlobalData.$axios_error)
        }else{
            jizen_dsp_error++
            setTimeout(function(){jizen_read()},"1000")
        }
        
    })
   
}
 */
// ログイン後に家族フラグを確認する
watch(login_status, (newValue, oldValue) => {
    if(newValue == 'login' && newValue != oldValue){
        family_flg_get()
    }
});
if(GlobalData.$taiken_flow == 1){
    // 未ログインならボタン表示
      if(GlobalData.user_id == null){

      }else{
        // ログイン済みなら実績を確認し、事前説明会未参加であれば表示
        axios.post(GlobalData.$API_URL+"Taikenuser_Jisseki", {taikenuser_id:GlobalData.user_id}, GlobalData.$ID_Token)
        .then(response => {
            console.log("実績読取完了")
            let myjisseki = response.data.jisseki  // 全実績
            
            for(let j = 0;j<myjisseki.length;j++){
                let jisseki_kobetsu = myjisseki[j]
                // 実績にプログラム区分２（事前説明会）がある場合
                if(jisseki_kobetsu["program_kbn"] == 2){
                    // 1つでも参加済みの事前説明会があれば非表示とする
                    if(jisseki_kobetsu["jokyo"] == '2'){
                        jizen_dsp.value = 0
                    }
                }
            }
        })
        .catch(error => {
            message.value = error + GlobalData.$axios_error;
            message_cat.value = 0;
            message_flag.value = true;
            message_method.value = "get_error";
            contentMessage.value = MessageModal
        })
      }
}else{
    jizen_dsp.value = 0
}

login_mode()

defineExpose({
  login_mode,
});
</script>
